/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {IHasUnconnectedDocuments} from './IHasUnconnectedDocuments';
import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import TSVorleistungDaten from './TSVorleistungDaten';

export default class TSVorleistung extends TSAbstractEntity implements TSSerializable<TSVorleistung>, IHasUnconnectedDocuments {

    private _vorleistungDatenGS: TSVorleistungDaten | undefined;
    private _vorleistungDatenFS: TSVorleistungDaten;
    private _documentIdsToConnect: Array<string> = [];
    private _schaetzung: boolean;

    deserialize(restObject: any): TSVorleistung {
        super.deserialize(restObject);

        this.vorleistungDatenFS = this.deserializeOrCreate(restObject.vorleistungDatenFS, new TSVorleistungDaten());
        this.vorleistungDatenGS = this.deserializeOrNull(restObject.vorleistungDatenGS, new TSVorleistungDaten());
        this.schaetzung = restObject.schaetzung;

        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.vorleistungDatenGS = this.serializeOrInit(this.vorleistungDatenGS, restObject.vorleistungDatenGS);
        restObject.vorleistungDatenFS = this.serializeOrInit(this.vorleistungDatenFS, restObject.vorleistungDatenFS);
        restObject.schaetzung = this.schaetzung;
        return restObject;
    }

    public static getDeserializer = (vorleistung: any) => {
        return new TSVorleistung().deserialize(vorleistung);
    };

    public static getSerializer = (vorleistung: any) => {
        return vorleistung.serialize(vorleistung);
    };

    public get vorleistungDatenGS(): TSVorleistungDaten | any {
        return this._vorleistungDatenGS;
    }

    public set vorleistungDatenGS(value: TSVorleistungDaten | any) {
        this._vorleistungDatenGS = value;
    }

    public get vorleistungDatenFS(): TSVorleistungDaten {
        return this._vorleistungDatenFS;
    }

    public set vorleistungDatenFS(value: TSVorleistungDaten) {
        this._vorleistungDatenFS = value;
    }

    public get documentIdsToConnect(): Array<string> {
        return this._documentIdsToConnect;
    }

    public set documentIdsToConnect(value: Array<string>) {
        this._documentIdsToConnect = value;
    }

    public get schaetzung(): boolean {
        return this._schaetzung;
    }

    public set schaetzung(value: boolean) {
        this._schaetzung = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSVorleistung.ts